var ssSvgContent = `
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#111111" viewBox="0 0 256 256">
  <path class="inactive" d="M178,32c-20.65,0-38.73,8.88-50,23.89C116.73,40.88,98.65,32,78,32A62.07,62.07,0,0,0,16,94c0,70,103.79,126.66,108.21,129a8,8,0,0,0,7.58,0C136.21,220.66,240,164,240,94A62.07,62.07,0,0,0,178,32ZM128,206.8C109.74,196.16,32,147.69,32,94A46.06,46.06,0,0,1,78,48c19.45,0,35.78,10.36,42.6,27a8,8,0,0,0,14.8,0c6.82-16.67,23.15-27,42.6-27a46.06,46.06,0,0,1,46,46C224,147.61,146.24,196.15,128,206.8Z"></path>
  <path class="active" d="M240,94c0,70-103.79,126.66-108.21,129a8,8,0,0,1-7.58,0C119.79,220.66,16,164,16,94A62.07,62.07,0,0,1,78,32c20.65,0,38.73,8.88,50,23.89C139.27,40.88,157.35,32,178,32A62.07,62.07,0,0,1,240,94Z"></path>
</svg>
`;

var scrollPosition = window.pageYOffset;

jQuery(function ($) {
  "use strict";
  $(document).ready(function () {
    if ($(document).find(".ss-product-grid-variants-holder").length) {
      productHoverVariants();
    }

    colorFilterHover();

    if ($(document).find(".product__info-container").length) {
      ssProductAccordion();
    }

    if ($(document).find(".frcp-popup-wrapper").length) {
      ssWishlistPopup();
    }

    $(document).on("click", 'a[href="#chat"]', function (event) {
      event.preventDefault();
      // console.log('here');
      Kustomer.open();
    });

    $(window).on("load", function () {
      $(document).find('a[href="#chat"]').css({
        opacity: 1,
        "pointer-events": "all",
      });

      const ssFiltersCount = $(
        "#FacetFiltersForm .facets__selected:not(.hidden)"
      );
      let ssTotalCount = 0;
      if (ssFiltersCount.length) {
        $.each(ssFiltersCount, function (indexInArray, valueOfElement) {
          ssTotalCount += parseInt($(this).text().replace(/[()]/g, ""));
        });
      }

      const catChildCount = $(
        '#FacetFiltersForm details[data-label="Category"] fieldset ul.no-js-hidden'
      ).children().length;
      if (catChildCount && catChildCount == 1) --ssTotalCount;

      const subCatChildCount = $(
        '#FacetFiltersForm details[data-label="Subcategory"] fieldset ul.no-js-hidden'
      ).children().length;
      if (subCatChildCount && subCatChildCount == 1) --ssTotalCount;

      if (ssTotalCount > 0) {
        $(".ss-filter-count").text(ssTotalCount);
        $(".ss-filter-count").removeClass("hidden");
        $(".ss-active-facets-mobile").removeClass("hidden");
        $("#FacetSortForm").addClass("ss-active-filters");
        $(".ss-active-facets-check").addClass("active");
      } else {
        $(".ss-filter-count").addClass("hidden");
        $(".ss-active-facets-mobile").addClass("hidden");
        $("#FacetSortForm").removeClass("ss-active-filters");
        $(".ss-active-facets-check").removeClass("active");
      }
    });

    $(document).on("click", 'a[href="/account/login"]', function (event) {
      if (!$(document).find(".frcp-popup-wrapper").length) return;

      if ($(document).find("body.template--customers-login").length) return;
      if ($(document).find("body.template--customers-register").length) return;

      console.log("Login Clicked");
      event.preventDefault();

      $(".frcp-login.frcp-popup").fadeIn();

      $(document)
        .find(".frcp-popup-wrapper.frcp-popup-wrapper--swall")
        .addClass("frcp-popup-wrapper--open");

      $(document)
        .find("body")
        .addClass("frcp-popup-open frcp-popup-open--swall");

      $(document)
        .find(".ss-wishlist-form-switch .ss--current")
        .removeClass("ss--current");
      $(document)
        .find(".ss-wishlist-form-switch .form-switch-login")
        .addClass("ss--current");

      $(document)
        .find(".frcp-popup__body")
        .removeClass("frcp-login--registration");
      $(document).find(".frcp-popup__body").addClass("frcp-login--login");
    });

    $(document).on("click", 'a[href="/account/register"]', function (event) {
      if (!$(document).find(".frcp-popup-wrapper").length) return;

      if ($(document).find("body.template--customers-login").length) return;
      if ($(document).find("body.template--customers-register").length) return;

      event.preventDefault();

      console.log("Register Clicked");
      $(document)
        .find(".frcp-popup-wrapper.frcp-popup-wrapper--swall")
        .addClass("frcp-popup-wrapper--open");

      $(document)
        .find("body")
        .addClass("frcp-popup-open frcp-popup-open--swall");

      $(document)
        .find(".ss-wishlist-form-switch .ss--current")
        .removeClass("ss--current");
      $(document)
        .find(".ss-wishlist-form-switch .form-switch-register")
        .addClass("ss--current");

      $(document).find(".frcp-popup__body").removeClass("frcp-login--login");
      $(document)
        .find(".frcp-popup__body")
        .addClass("frcp-login--registration");
    });

    $("body.dark_mode .header .list-menu--inline .header__menu-item").hover(
      function () {
        $(this).parent().siblings().find("span").css("color", "#888888");
      },
      function () {
        $(this).parent().siblings().find("span").css("color", "#e6e6e6");
      }
    );
    $("body.dark_mode .header .list-menu--inline > li.search__item").hover(
      function () {
        $(this).parent().find("span").css("color", "#888888");
      },
      function () {
        $(this).parent().find("span").css("color", "#e6e6e6");
      }
    );

    $(document).on(
      "click",
      ".product-form__input a.color_swatch",
      function (event) {
        event.preventDefault();

        if ($(this).parents(".ss-product-quick-view-content").length) return;

        if ($(this).hasClass("active")) return;

        console.log("Button Pressed");

        var url = $(this).attr("href");

        const sectionID = $(document)
          .find("#MainContent")
          .find(".ss-data-section")
          .data("section");

        // Define the URL to retrieve the product data from
        // var url = $(this).attr('href');
        // Use jQuery's ajax() method to retrieve the data
        $.ajax({
          url: url,
          dataType: "json",
          success: function (data) {
            const request = new XMLHttpRequest();
            request.addEventListener("load", handleResponse);
            request.open(
              "GET",
              `/products/${data.product.handle}/?section_id=${sectionID}`,
              true
            );
            request.send();

            function handleResponse() {
              const resInnerHTML = new DOMParser()
                .parseFromString(this.responseText, "text/html")
                .getElementById(`shopify-section-${sectionID}`).innerHTML;

              $(document).find(`#ProductModal-${sectionID}`).remove();

              document.getElementById(
                `shopify-section-${sectionID}`
              ).innerHTML = resInnerHTML;

              window.scrollTo({ top: 0, behavior: "smooth" });

              const stampedMain = document.getElementById(
                "stamped-main-widget"
              );
              if (stampedMain) {
                stampedMain.querySelector(".stamped-container").remove();
                stampedMain.setAttribute("data-product-id", data.product.id);

                StampedFn.reloadUGC();
              }

              document.querySelectorAll(".accordion details").forEach((el) => {
                new Accordion(el);
              });

              document
                .querySelectorAll(".color_swatch")
                .forEach(function (obj) {
                  obj.onmouseover = function () {
                    var color = obj.getAttribute("data-value");
                    document
                      .querySelectorAll(".current_color")
                      .forEach(function (obj1) {
                        obj1.textContent = color;
                      });
                  };

                  obj.onmouseout = function () {
                    document
                      .querySelectorAll(".current_color")
                      .forEach(function (obj1) {
                        obj1.textContent = obj1.getAttribute("data-value");
                      });
                  };
                });

              ssWishlistInit().then(function () {
                // updatePDPwishlishIcon(
                //   ".frcp-wishlist-wrapper .frcp-wishlist-btn__text"
                // );
                // if ("createEvent" in document) {
                //   var evt = document.createEvent("HTMLEvents");
                //   evt.initEvent("change", false, true);
                //   document.querySelector("variant-radios").dispatchEvent(evt);
                // } else {
                //   document
                //     .querySelector("variant-radios")
                //     .fireEvent("onchange");
                // }
              });

              ssWaitlistHover();

              window.history.pushState(null, null, data.product.handle);
            }
          },
          error: function (xhr, status, error) {
            // Handle errors
            console.log(xhr.responseText);
          },
        });
      }
    );

    $(document).on("change", ".ss-sortby-input", function (event) {
      $("#SortBy").val($(this).val());
      console.log($(this).val());
    });

    // Click event handler for the document
    $(document).on("click", function (event) {
      if (!$(event.target).closest(".ss-header-sortby-container").length) {
        $(document).find(".ss-sortBy-list.active").removeClass("active");
      }
    });

    $(document).on("click", ".ss-header-sortby-container", function (event) {
      $(this).children(".ss-sortBy-list").toggleClass("active");
    });

    document.addEventListener("scroll", function () {
      if (document.querySelector(".ss-product-info-wrapper") != null) {
        requestAnimationFrame(function () {
          calcPlacement();
        });
      }
    });

    $(document).on("click", ".shipping_note > div", function (event) {
      // $("body").addClass("overflow-hidden");
      $("body").css("overflow", "hidden");

      $(document).find(".ss_shipping_return_popup").addClass("active");

      setTimeout(() => {
        $(document).find(".custom-tab-wrapper").addClass("active");
      }, 1);
      if ($(this).hasClass("fast-ship")) {
        $(document)
          .find(".custom-tab-inner-wrapper.shipping")
          .addClass("active");
      } else {
        $(document)
          .find(".custom-tab-inner-wrapper.returns")
          .addClass("active");
      }

      return;

      const shipping_html = generateShippingElement();
      const returns_html = generateReturnsElement();

      let shipping_return_popup =
        '<div class="ss_shipping_return_popup"><div class="custom-tab-wrapper"><div class="custom-tab-inner-wrapper">';

      shipping_return_popup += $(this).hasClass("fast-ship")
        ? shipping_html
        : returns_html;

      const currURl = $(this).hasClass("fast-ship")
        ? "https://www.dstnc.com/shipping"
        : "https://www.dstnc.com/returns";

      shipping_return_popup += `<div class="shipping_returns_info"><a href="${currURl}">More information</a></div>`;

      shipping_return_popup += "</div></div></div>";

      $("body").append(shipping_return_popup);

      document.querySelectorAll(".accordion details").forEach((el) => {
        new Accordion(el);
      });

      setTimeout(() => {
        $(document).find(".custom-tab-wrapper").addClass("active");
      }, 1);
    });

    $(document).on("click", ".ss-main-nav-ul summary", function (event) {
      event.preventDefault();
      $(this).next(".menu-drawer__submenu").slideToggle("fast");
      $(this).toggleClass("ss-icon-rotated");
    });

    // $(document).on(
    //   "click",
    //   ".footer.footer .footer__content-top.ss-footer-accordions .footer-block__heading",
    //   function (event) {
    //     if ($(window).width() > 989) return;
    //     event.preventDefault();

    //     const $heading = $(this);
    //     const $content = $heading.next(".footer-block__details-content");

    //     // toggle the arrow-rotation
    //     $heading.toggleClass("ss-icon-rotated");

    //     if ($content.is(":visible")) {
    //       // CLOSE: animate height → 0, then hide and reset
    //       $content
    //         .stop(true) // cancel any running animation
    //         .animate({ height: 0 }, "fast", () => {
    //           $content.css({ display: "none", height: "" });
    //         });
    //     } else {
    //       // OPEN: prepare for flex + height=0
    //       const fullHeight = $content.get(0).scrollHeight;
    //       $content
    //         .css({ display: "flex", height: 0, overflow: "hidden" })
    //         .animate({ height: fullHeight }, "fast", () => {
    //           $content.css({ height: "", overflow: "" });
    //         });
    //     }
    //   }
    // );
    $(document).on(
      "click",
      ".footer.footer .footer__content-top.ss-footer-accordions .footer-block__heading",
      function (event) {
        if ($(window).width() > 989) return;
        event.preventDefault();
        $(this)
          .next(".ss-footer-block__details-content-holder")
          .slideToggle("fast");
        $(this).toggleClass("ss-icon-rotated");
      }
    );

    $(document).on(
      "click",
      ".ss-mega-menu ul li .ss-summary",
      function (event) {
        event.preventDefault();

        $(".ss-mega-menu ul li .mega-menu__content")
          .not($(this).next(".mega-menu__content"))
          .hide();

        $(".ss-mega-menu")
          .find(".ss-mega-item-active")
          .removeClass("ss-mega-item-active");

        if ($(this).next(".mega-menu__content").is(":visible")) {
          $(this).next(".mega-menu__content").hide();
          $(this).removeClass("ss-mega-item-active");
          $(this)
            .next(".mega-menu__content")
            .removeClass("ss-mega-item-active");
          $(this).parents("sticky-header").removeClass("ss-mega-menu-active");

          $("body").removeClass("overflow-hidden");
        } else {
          $(this).next(".mega-menu__content").show();
          $(this).addClass("ss-mega-item-active");
          $(this).next(".mega-menu__content").addClass("ss-mega-item-active");
          $(this).parents("sticky-header").addClass("ss-mega-menu-active");

          $("body").addClass("overflow-hidden");
        }
      }
    );

    // Click event handler for the document
    $(document).click(function (event) {
      // Check if the click target is not inside the submenu or its parent
      if (!$(event.target).closest(".ss-mega-item-active").length) {
        // Hide all submenus when clicking outside of them or their parent
        $(".ss-mega-menu ul li .mega-menu__content").hide();
        $(".ss-mega-menu")
          .find(".ss-mega-item-active")
          .removeClass("ss-mega-item-active");
        $("sticky-header").removeClass("ss-mega-menu-active");
        $("body").removeClass("overflow-hidden");
      }
    });

    $("a.btn-gradient-bg").each(function () {
      $("a.btn-gradient-bg").mousemove(function (event) {
        var x = event.pageX - $(this).offset().left;
        var y = event.pageY - $(this).offset().top;
        var translateX1 = ((x - $(this).width() / 2) / $(this).width()) * 100;
        var translateY1 = ((y - $(this).height() / 2) / $(this).height()) * 100;
        var translateX2 = -translateX1;
        var translateY2 = -translateY1;
        $(this)
          .find(".gradient__ball--1")
          .css({
            transform: `translate3d(${translateX1}%, ${translateY1}%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)`,
            "will-change": "transform",
            "transform-style": "preserve-3d",
          });
        $(this)
          .find(".gradient__ball--2")
          .css({
            transform: `translate3d(${translateX2}%, ${translateY2}%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)`,
            "will-change": "transform",
            "transform-style": "preserve-3d",
          });
      });
      $("a.btn-gradient-bg").hover(
        function () {
          $(this).find(".gradient-wrap").stop().animate(
            {
              opacity: 0.75,
            },
            250
          );
        },
        function () {
          $(this).find(".gradient-wrap").stop().animate(
            {
              opacity: 0,
            },
            250
          );
        }
      );
    });

    $(".header .list-menu--inline .ss-activate-search").on(
      "click",
      function (event) {
        event.preventDefault();
        $(document).find("input#Search-In-Modal--3").focus();
      }
    );

    $(".ss-mbl-search-modal-container .search-cancel").on(
      "click",
      function (event) {
        event.preventDefault();
        $(document)
          .find(".ss-mbl-search-modal-container")
          .removeClass("active");
        document.body.style.overflow = "visible";
      }
    );

    $(document).on("click", ".wear-it-with .view-more", function (event) {
      event.preventDefault();

      const grid = $(this).siblings(".products-wrapper").children("ul.grid");

      grid.toggleClass("active");

      if (grid.hasClass("active")) {
        $(this).text("View less");
      } else {
        $(this).text("View more");
      }
    });

    ssWaitlistHover();

    // Initial check when the page loads
    // checkWindowWidth();
  });

  $(document).on("click", function (e) {
    var popup = $(".custom-tab-wrapper.active");

    if (!popup.length) return;

    if (
      !popup.is(e.target) &&
      !$(".custom-tab-wrapper.active").is(e.target) &&
      popup.has(e.target).length === 0
    ) {
      $(document).find(".custom-tab-wrapper").removeClass("active");
      // $("body").removeClass("overflow-hidden");
      $("body").css("overflow", "visible");
      setTimeout(() => {
        $(".ss_shipping_return_popup").removeClass("active");
        $(document)
          .find(".custom-tab-inner-wrapper.active")
          .removeClass("active");
      }, 250);
    }
  });

  $(document).on(
    "click",
    ".ss_shipping_return_popup .shipping_returns_title .exit",
    function (event) {
      event.preventDefault();
      $(document).find(".custom-tab-wrapper").removeClass("active");
      // $("body").removeClass("overflow-hidden");
      $("body").css("overflow", "visible");
      setTimeout(() => {
        $(".ss_shipping_return_popup").removeClass("active");
        $(document)
          .find(".custom-tab-inner-wrapper.active")
          .removeClass("active");
      }, 250);
    }
  );

  $(document).on("swiperight", ".custom-tab-wrapper", function () {
    // Hide the div by moving it out of the viewport
    console.log("Swipe Right");
    $(document).find(".custom-tab-wrapper").removeClass("active");
    // $("body").removeClass("overflow-hidden");
    $("body").css("overflow", "visible");
    setTimeout(() => {
      $(".ss_shipping_return_popup").removeClass("active");
      $(document)
        .find(".custom-tab-inner-wrapper.active")
        .removeClass("active");
    }, 250);
  });

  function generateReturnsElement() {
    const returns_array = [
      {
        title: "Free 30-day returns on all U.S. orders",
        content:
          "<p>If you are not completely satisfied with your purchase or you simply wish to return it, you have 30-days from the day your order was delivered to send it back to us. Returns are complementary and hassle-free. All products must be returned in a new and unused state, in perfect condition, and with all original tags attached.</p>",
      },
      {
        title: "Exchanges",
        content:
          "<p>At this time we are unable to offer exchanges. If you’d like to exchange an item please return it for a refund or store credit and place a new order for your new item.</p>",
      },

      {
        title: "How to make a return?",
        content: `
      <ul>
        <li>Click here to start your return or simply log in to your account</li>
        <li>Enter your order number, email or zip for identification and click “Get Started” </li>
        <li>Select the items you want to return from your order and select the return reason</li>
        <li>Select your return credit option: Refund or Store Credit and click “Complete” </li>
        <li>Download our pre-paid Return Label and attach it to your package (remove or cover any previous shipping labels to avoid shipping delays)</li>
        <li>Drop off your return at any USPS location. Make sure to keep your receipt</li>
      </ul>
    `,
      },

      {
        title: "Final-Sale items",
        content:
          '<p>Items marked "Final Sale" cannot be returned once purchased.</p>',
      },

      {
        title: "Refund processing",
        content:
          "<p>Returns are processed within 3-5 business days after they arrive at our warehouse. Refunds will be credited to the original form of payment, and a confirmation email will be sent to you once it has been issued. It may take up to 7 additional days for the funds to show in your account.</p>",
      },

      {
        title: "Late or refused returns",
        content:
          "<p>Your item(s) should be sent back to us within 30 days of receiving you order. Returns outside this timeframe may be accepted at our discretion and may only be refunded as a store credit. We reserve the right not to accept returns if the product shows signs of wear or has been used or altered from its original condition in any way.</p>",
      },

      {
        title: "Shoes",
        content:
          "<p>All shoes should be tried on a carpeted surface and returned in a new, unused condition with the original tags, shoe box, and packaging. Cleats should not be installed on cycling shoes. Returns without a shoe box, in a damaged shoe box, or with scratched soles will not be accepted and will be sent back.</p>",
      },
    ];

    let returns_html =
      "<h2 class='shipping_returns_title'>Returns<span class='exit'></span></h2>";

    $.each(returns_array, function (indexInArray, valueOfElement) {
      let i = indexInArray;
      returns_html += generateAccordionElement(
        `ss-returns-row-${++i}`,
        valueOfElement.title,
        valueOfElement.content,
        indexInArray == 0 ? "open" : ""
      );
    });

    return returns_html;
  }

  function generateShippingElement() {
    const shipping_array = [
      {
        title: "Free U.S. shipping",
        content:
          "<p>We offer free express shipping on all U.S. orders. Orders are shipped via all major carriers (UPS, DHL, FedEx, USPS) and should arrive within 3 to 5 business days.</p>",
      },
      {
        title: "Processing time",
        content:
          "<p>Most orders are shipped within 1-2 business day. Processing time is in addition to transit/delivery time. Once your order ships you will receive a confirmation email with your shipment and tracking details.</p>",
      },
      {
        title: "Delivery",
        content: `<p>If you order multiple items, you may get multiple deliveries. We’ll send you a shipping confirmation email for each shipment along with shipping notifications throughout transit so you’ll know exactly what to expect and when to expect it.</p>`,
      },
      {
        title: "P.O. Boxes and APO/FPO",
        content: `<p>At this time we do not ship to P.O. Boxes or APO/FPO addresses.</p>`,
      },
      {
        title: "International shipping",
        content: `<p>At this time, we are not able to ship to countries outside the U.S.</p>`,
      },
      {
        title: "Possible delays",
        content: `<p>We do our best to ensure the timely delivery of all orders. Please keep in mind that we are only provided with an estimated delivery date from our carriers and cannot guarantee delivery estimates.</p>`,
      },
    ];

    let shipping_html =
      "<h2 class='shipping_returns_title'>Shipping<span class='exit'></span></h2>";

    $.each(shipping_array, function (indexInArray, valueOfElement) {
      let i = indexInArray;
      shipping_html += generateAccordionElement(
        `ss-shipping-row-${++i}`,
        valueOfElement.title,
        valueOfElement.content,
        indexInArray == 0 ? "open" : ""
      );
    });

    return shipping_html;
  }

  function generateAccordionElement(id, title, content, open = "") {
    return `
      <div class="popop product__accordion accordion">
        <details id="Details-${id}" ${open}>
          <summary aria-expanded="true" role="button" aria-controls="${id}">
            <div class="summary__title">
              <span class="h4 accordion__title">${title}</span>
            </div>
            <span class="accordion-indicator"></span>
          </summary>
          <div class="accordion__content rte" id="${id}">${content}</div>
        </details>
      </div>
    `;
  }

  function calcPlacement() {
    const windowHeight = window.innerHeight;
    const componentWrapper = document.querySelector(".ss-product-info-wrapper");
    const componentHeight = componentWrapper.clientHeight;
    const navAndBreadcrumbsHeight = 80;

    const scrollYPosition = window.scrollY;
    const isScrollingDown = scrollYPosition >= scrollPosition;

    const componentBoundingRect = componentWrapper.getBoundingClientRect(); // Component
    const containerBoundingRect = document
      .querySelector(".product__info-wrapper")
      .getBoundingClientRect(); // Container

    if (componentHeight <= windowHeight - navAndBreadcrumbsHeight) {
      setPosition("sticky", navAndBreadcrumbsHeight);
    } else if (
      isScrollingDown &&
      Math.abs(componentBoundingRect.top - navAndBreadcrumbsHeight) >=
        Math.max(componentHeight - windowHeight + navAndBreadcrumbsHeight, 0)
    ) {
      setPosition("sticky", windowHeight - componentHeight);
    } else if (
      !isScrollingDown &&
      componentBoundingRect.top >= navAndBreadcrumbsHeight
    ) {
      setPosition("sticky", navAndBreadcrumbsHeight);
    } else {
      setPosition(
        "relative",
        -1 * containerBoundingRect.y + componentBoundingRect.top
      );
    }

    scrollPosition = Math.max(scrollYPosition, 0);
  }
});

function ssWishlistInit() {
  return new Promise(function (resolve, reject) {
    frcp.wishlist.initialize();
    resolve();
  });
}

function setPosition(t, e) {
  document.querySelector(".ss-product-info-wrapper").style.position = t;
  document.querySelector(".ss-product-info-wrapper").style.top = e + "px";
}

function productHoverVariants() {
  $(document).on(
    "mouseenter",
    ".ss-product-grid-variants-holder .color_swatch",
    function () {
      $(this)
        .parents(".ss-product-grid-variants-holder")
        .siblings(".card__inner")
        .find(".card__media")
        .children(".media")
        .children("img")
        .attr("src", $(this).data("image"));
    }
  );

  $(document).on(
    "mouseleave",
    ".ss-product-grid-variants-holder .color_swatch",
    function () {
      const currImage = $(this)
        .parents(".ss-product-grid-variants-holder")
        .siblings(".card__inner")
        .find(".card__media")
        .children(".media")
        .data("image");

      $(this)
        .parents(".ss-product-grid-variants-holder")
        .siblings(".card__inner")
        .find(".card__media")
        .children(".media")
        .children("img")
        .attr("src", currImage);
    }
  );

  return;
}

function colorFilterHover() {
  $(document).on(
    "mouseenter",
    "fieldset.filter-color .swatch_filter input",
    function () {
      $(this)
        .parents("details")
        .children("summary")
        .find(".color-name-hover")
        .text($(this).attr("title"));
      $(this)
        .parents("details")
        .children("summary")
        .find(".color-name-hover")
        .addClass("active");
    }
  );

  $(document).on(
    "mouseleave",
    "fieldset.filter-color .swatch_filter input",
    function () {
      $(this)
        .parents("details")
        .children("summary")
        .find(".color-name-hover")
        .removeClass("active");
    }
  );

  return;
}

function ssProductAccordion() {
  if (
    $(document)
      .find(".product__info-container")
      .find(".metafield-multi_line_text_field")
      .is(":empty")
  ) {
    $(document)
      .find(".product__info-container")
      .find(".metafield-multi_line_text_field")
      .parent("p")
      .hide();
  }
}

function ssWishlistPopup() {
  // const formSwitch = `
  //   <div class="ss-wishlist-form-logo">
  //     <img src="https://assets-global.website-files.com/5f239bcd7c30a344fa10b9b5/63b9368fd0a7063889a043a4_moshed-2023-0-6-11-46-43_AdobeExpress.gif" loading="lazy" alt="">
  //   </div>
  //   <div class="ss-wishlist-form-switch">
  //     <div class="form-switch form-switch-register">Register</div>
  //     <div class="form-switch form-switch-login ss--current">Log in</div>
  //   </div>
  // `;
  const formSwitch = `
    <div class="ss-wishlist-form-switch">
      <div class="form-switch form-switch-register">Register</div>
      <div class="form-switch form-switch-login ss--current">Log in</div>
    </div>
  `;

  $(document)
    .find(".frcp-popup-wrapper")
    .find(".frcp-popup__body")
    .prepend(formSwitch);

  $(document)
    .find(".frcp-popup-wrapper")
    .find(".frcp-popup__body")
    .append(
      `<div class="form__disclaim">By signing up, you agree to DSTNC's <a href="https://www.dstnc.com/privacy-policy">Privacy Policy </a>and <a href="https://www.dstnc.com/terms-and-condition">Terms of Use.</a></div>`
    );

  const formCloseSVG = `
      <svg width="420" height="420" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.0002 10.586L16.9502 5.63599L18.3642 7.04999L13.4142 12L18.3642 16.95L16.9502 18.364L12.0002 13.414L7.05023 18.364L5.63623 16.95L10.5862 12L5.63623 7.04999L7.05023 5.63599L12.0002 10.586Z" fill="currentColor"></path>
      </svg>
    `;
  $(document)
    .find(".frcp-popup-wrapper")
    .find(".frcp-popup__header")
    .find(".frcp-popup__close")
    .html(formCloseSVG);

  $(document).on(
    "click",
    ".ss-wishlist-form-switch .form-switch:not(a)",
    function (event) {
      event.preventDefault();
      if ($(this).hasClass("ss--current")) return;

      $(document)
        .find(".ss-wishlist-form-switch .ss--current")
        .removeClass("ss--current");
      $(this).addClass("ss--current");

      $(document)
        .find(".frcp-popup__body")
        .toggleClass("frcp-login--login frcp-login--registration");
    }
  );

  $.each(
    $(".frcp-login .frcp-form__field"),
    function (indexInArray, valueOfElement) {
      $(this).addClass($(this).children("label").attr("for"));
    }
  );

  $(".frcp-login .frcp-form__field > input").focus(function () {
    $(this).prev("label").addClass("focused");
  });

  $(".frcp-login .frcp-form__field > input").blur(function () {
    if ($(this).val() === "") $(this).prev("label").removeClass("focused");
  });
  $(".frcp-popup__close").on("click", function (e) {
    e.preventDefault();
  });
  $(document).on("click", function (event) {
    if (
      $(event.target).closest(".frcp-popup").length === 0 &&
      $(event.target).closest(".frcp-wishlist-btn").length === 0 &&
      $(event.target).closest(".header__icon").length === 0 &&
      $(".frcp-popup-wrapper").is(":visible")
    ) {
      $(document)
        .find(".frcp-popup-wrapper.frcp-popup-wrapper--swall")
        .removeClass("frcp-popup-wrapper--open");
      $(document)
        .find("body")
        .removeClass("frcp-popup-open frcp-popup-open--swall");
    }
  });
}

window.addEventListener("load", function () {
  if (document.querySelector(".frcp-wishlist-btn__icon") != null) {
    document
      .querySelectorAll(".frcp-wishlist-btn__icon")
      .forEach(function (el) {
        el.innerHTML = ssSvgContent;
        el.style.opacity = 1;
      });
  }
  if (
    document.querySelector(
      '.frcp-nav-button[data-to="#/wishlist"] .frcp-icon'
    ) != null
  ) {
    const frcpEl = '.frcp-nav-button[data-to="#/wishlist"] .frcp-icon';
    updatePDPwishlishIcon(frcpEl);
  }
});

// if (
//   document.querySelector(".frcp-wishlist-wrapper .frcp-wishlist-btn__text") !=
//   null
// )
//   updatePDPwishlishIcon(".frcp-wishlist-wrapper .frcp-wishlist-btn__text");

document.addEventListener("frcp.wishlist.update", function () {
  // const frcpEl = ".frcp-wishlist-wrapper .frcp-wishlist-btn__text";
  // if (document.querySelector(frcpEl) != null) updatePDPwishlishIcon(frcpEl);
});

function updatePDPwishlishIcon(frcpEl) {
  document.querySelector(frcpEl).innerHTML = ssSvgContent;
  document.querySelector(frcpEl).style.opacity = 1;
}

// Function to check the window width and call the appropriate handler
function checkWindowWidth() {
  // Get the window width
  var windowWidth = window.innerWidth;

  // Check if the window width is less than 768px
  if (windowWidth < 768) {
    if (
      document.querySelector(
        '#FacetsWrapperDesktop details[data-label="Gender"]'
      )
    )
      document
        .querySelector('#FacetsWrapperDesktop details[data-label="Gender"]')
        .removeAttribute("open");
  }
}

function ssWaitlistHover() {
  var ssWishlistHover = document.querySelectorAll(".ss-wishlist-hover");
  var hoverNotifications = document.querySelectorAll(".ss-hover-notification");

  if (!isTouchDevice()) {
    ssWishlistHover.forEach(function (promoCode, index) {
      promoCode.addEventListener("mouseover", function () {
        showHoverNotification(promoCode, hoverNotifications[index]);
      });

      promoCode.addEventListener("mouseout", function () {
        hideHoverNotification(hoverNotifications[index]);
      });
    });
  }
}
function isTouchDevice() {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

function hideHoverNotification(notification) {
  notification.style.opacity = "0";
  notification.style.top = "-25px";
  setTimeout(function () {
    notification.style.visibility = "hidden";
  }, 250);
}

function showHoverNotification(promo, notification) {
  notification.style.visibility = "visible";
  notification.style.opacity = "1";
  notification.style.top = "-35px";
}

document.addEventListener("DOMContentLoaded", function () {
  // Follow Brand
  const followButton = document.getElementById("ss-follow-brand");
  if (followButton) {
    followButton.addEventListener("click", async (event) => {
      event.preventDefault();

      // Prevent multiple clicks during loading
      if (followButton.classList.contains("loading")) return;

      const customerId = followButton.getAttribute("data-customer-id");
      const brandTag = followButton.getAttribute("data-brand");

      // Validate inputs
      if (!customerId || !brandTag) {
        console.log("Missing customer ID or brand tag.");
        return;
      }

      const appendUrl =
        "https://dstnc-brand-follow-b09e47b65a4e.herokuapp.com/append-tags";
      const removeUrl =
        "https://dstnc-brand-follow-b09e47b65a4e.herokuapp.com/remove-tags";

      // Determine the action: follow (append tag) or unfollow (remove tag)
      const isFollowing = followButton.classList.contains("following");
      const url = isFollowing ? removeUrl : appendUrl;
      const action = isFollowing ? "Unfollowing" : "Following";

      const data = {
        customerId: customerId,
        tags: brandTag,
      };

      // Add loading animation
      followButton.classList.add("loading");

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });

        if (!response.ok) {
          throw new Error(`Error: ${response.status}`);
        }

        // Success feedback
        console.log(`${action} successful`);

        // Update button state
        if (isFollowing) {
          followButton.classList.remove("btn-m-fill", "following");
          followButton.querySelector("span.btn-text").innerText = "Follow";
        } else {
          followButton.classList.add("btn-m-fill", "following");
          followButton.querySelector("span.btn-text").innerText = "Following";
        }
      } catch (error) {
        console.log("Error: ", error.message);
      } finally {
        // Remove loading animation
        followButton.classList.remove("loading");
      }
    });
  }

  const followBtnLogin = document.getElementById("ss-follow-brand-login");
  if (followBtnLogin) {
    followBtnLogin.addEventListener("click", (event) => {
      event.preventDefault();
      frcp.wishlist.showLogin();
    });
  }

  customScrollBar();
});

function customScrollBar() {
  const scrollArea = document.querySelector(
    ".product__media-wrapper .product_media-wrapper .product__media-list"
  );

  if (scrollArea) {
    // Create and insert custom scrollbar elements
    const scrollbar = document.createElement("div");
    scrollbar.className = "ss-custom-scrollbar";

    const thumb = document.createElement("div");
    thumb.className = "ss-custom-scrollbar-thumb";
    thumb.id = "ssCustomThumb";

    scrollbar.appendChild(thumb);
    scrollArea.parentElement.appendChild(scrollbar);

    const customThumb = document.getElementById("ssCustomThumb");

    function updateThumb() {
      const scrollWidth = scrollArea.scrollWidth;
      const clientWidth = scrollArea.clientWidth;
      const scrollLeft = scrollArea.scrollLeft;

      const thumbWidth = (clientWidth / scrollWidth) * clientWidth;
      const thumbLeft = (scrollLeft / scrollWidth) * clientWidth;

      customThumb.style.width = `${thumbWidth}px`;
      customThumb.style.left = `${thumbLeft}px`;
    }

    scrollArea.addEventListener("scroll", updateThumb);
    window.addEventListener("resize", updateThumb);
    window.addEventListener("load", updateThumb);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const tabLinks = document.querySelectorAll(".ss-mbl-tab-item-link");
  const tabContents = document.querySelectorAll(".ss-mobile-menu-container");

  tabLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      // Remove "current" class from all tab links
      tabLinks.forEach((item) => item.classList.remove("current"));

      // Add "current" to the clicked link
      this.classList.add("current");

      const targetTab = this.getAttribute("data-tab-target");

      // Hide all tab content
      tabContents.forEach((content) => {
        content.classList.add("hidden");
        content.style.opacity = "";
        content.style.transition = "";
      });

      // Show the selected tab content
      const activeTab = document.querySelector(`[data-tab="${targetTab}"]`);
      if (activeTab) {
        activeTab.classList.remove("hidden");
        activeTab.style.opacity = 0;
        activeTab.style.transition = "all, opacity 300ms";

        // tiny delay so the browser sees opacity=0 first
        setTimeout(() => {
          activeTab.style.opacity = 1;
        }, 20);
      }
    });
  });
});
